import { useRef } from 'react';
import { Container, Stack, Typography } from '@mui/material';

import Button from 'components/Common/Button';

function ImageUploadContainer({ imgValue, setImgValue }: { imgValue: any; setImgValue: any }) {
    const ref: any = useRef(null);

    const handleClick = () => {
        ref.current && ref.current.click();
    };
    const handleImageChange = (event: any) => {
        setImgValue(event.target.files[0]);
    };
    const getBlobUrl = (img: any) => {
        if (!img) return '';
        if (typeof img === 'string' && img?.includes('http://api-dev.liftcommerce.com')) return img;
        return URL.createObjectURL(img);
    };
    return (
        <Container
            sx={{
                width: 'auto',
                justifyContent: 'center',
                alignItems: 'center',
                p: 6,
                display: 'flex',
                flexDirection: 'column',
                borderStyle: 'dotted',
                my: 6,
                borderColor: '#D1D5DB',
            }}
        >
            <Typography sx={{ fontSize: 18, fontWeight: 400 }}>Drag and drop file here to upload</Typography>
            or
            <Button
                onClick={handleClick}
                backgroundColor="white"
                fontSize={14}
                variant="outlined"
                sx={{
                    my: 1,
                }}
                title="Select File"
            />
            <input ref={ref} type={'file'} onChange={handleImageChange} style={{ visibility: 'hidden' }} />
            {/* <Typography sx={{ fontSize: 12 }}>
                Maximum upload file size is 20 MB.
            </Typography> */}
            {imgValue && (
                <Stack direction="row" justifyContent="center" alignItems="center" sx={{ maxWidth: '200px', maxHeight: '200px' }}>
                    <img src={getBlobUrl(imgValue)} alt="profile pic" style={{ width: '200px', height: '200px', objectFit: 'contain' }} />
                </Stack>
            )}
        </Container>
    );
}

export default ImageUploadContainer;
